import { useLocalSearchParams } from 'expo-router'
import { QRLightBoxScreen } from '@/screens/qr-lightbox-screen'

export default function QRCodeRoute() {
  const { url, bg, description } = useLocalSearchParams<{ url?: string; bg?: string; description?: string }>()
  return <QRLightBoxScreen url={url} backgroundColor={bg} description={description} />
}
